import axios from "axios";
import { API_DOMAIN } from "../config/env";
import { getHeaders, processError } from "../helpers/service-helper";

axios.defaults.baseURL = API_DOMAIN;
axios.defaults.withCredentials = true;

export const login = async ({ email, password }) => {
    await axios.get("/sanctum/csrf-cookie", {
        headers: {
            "Access-Control-Allow-Credentials": true,
        },
    });

    try {
        const response = await axios.post(
            `/api/login`,
            {
                logUsuario: email,
                passwordUsuario: password,
            },
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        return processError(error);
    }
};

export const checkAuthStatus = async () => {
    try {
        const resp = await axios.post(
            `/api/auth/checkAuthStatus`,
            {},
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const logout = async () => {
    try {
        const resp = await axios.get(
            `/api/auth/logout`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
